import Mustache from 'mustache';
import helper from './helper';

let is_Modal = false;
let modal_window = $('<div></div>', { class: 'sst-modal' });
let click_area = $('<div></div>', { class: 'sst-click-area' });
let modal_overlay = $('<div></div>', { class: 'sst-modal__overlay' });

let methods = {
    init: function (options) {
        let template = $('#' + options.template);

        if (template.length && !is_Modal) {
            modal_window.html(Mustache.render(template.html(), options));
            $('body').append(modal_window).append(modal_overlay);

            methods.show();
        } else if (template.length && is_Modal) {
            if (needForAnimation()) {
                let oldModalContainer = modal_window.find(
                    '.sst-modal__container'
                );
                let newModalContainer;

                $('body').addClass('sst-modal__toggle');

                TweenLite.to(oldModalContainer, 0.2, {
                    rotationX: '90deg',
                    autoAlpha: 1,
                    onComplete: function () {
                        oldModalContainer.replaceWith(
                            Mustache.render(template.html(), options)
                        );

                        newModalContainer = modal_window
                            .find('.sst-modal__container')
                            .not(oldModalContainer);

                        TweenLite.set(newModalContainer, {
                            rotationX: '-90deg',
                            autoAlpha: 1,
                        });
                        TweenLite.to(newModalContainer, 0.2, {
                            rotationX: 0,
                            autoAlpha: 1,
                            onComplete: function () {
                                oldModalContainer.remove();
                                $('.sst-modal__container').removeAttr('style');
                                $('body').removeClass('sst-modal__toggle');
                                helper.triggerEvent(document, 'modal.open');
                            },
                        });
                    },
                });
            } else {
                modal_window
                    .find('.sst-modal__container')
                    .replaceWith(Mustache.render(template.html(), options));
                helper.triggerEvent(document, 'modal.open');
            }
        }
    },
    show: function () {
        $('body')
            .addClass('sst-disable-scroll')
            .css({ 'padding-right': helper.scrollBarWidth() });
        $('.notifications').css({ right: helper.scrollBarWidth() });

        setTimeout(function () {
            $('body').addClass('sst-modal__on');

            helper.triggerEvent(document, 'modal.open');
            // $(document).trigger('modalopen')
        }, 10);
        setTimeout(function () {
            modal_window.prepend(click_area);
            escKey();
            is_Modal = true;
        }, 500);
    },
    close: function () {
        $('body').removeClass('sst-modal__on');

        if (needForAnimation()) {
            setTimeout(removeModal, 400);
        } else {
            removeModal();
        }

        is_Modal = false;
    },
};

$(document).on('click', '.sst-click-area', function () {
    methods.close();
});

function removeModal() {
    modal_window.remove();
    modal_overlay.remove();
    $('body').removeClass('sst-disable-scroll').css({ 'padding-right': '' });
    $('.notifications').css({ right: '' });
    helper.triggerEvent(document, 'modal.close');
}

function needForAnimation() {
    return $(window).innerWidth() >= 720 ? true : false;
}

function escKey() {
    $(document).on('keyup.sst', function (e) {
        if (e.keyCode == 27 && is_Modal) {
            methods.close(); // esc
            $(document).off('keyup.sst');
        }
    });
}

export default function (method) {
    if (methods[method]) {
        return methods[method].apply(
            this,
            Array.prototype.slice.call(arguments, 1)
        );
    } else if (typeof method === 'object' || !method) {
        return methods.init.apply(this, arguments);
    } else {
        $.error('Метод с именем ' + method + ' не существует для jQuery.Modal');
    }
}
